// api/stream.js
import historyProvider from './historyProvider.js'
import * as globalConstant from './global_constant';
// we use Socket.io client to connect
var io = require('socket.io-client')
//var socket_url = 'wss://streamer.cryptocompare.com'
var socket_url = globalConstant.SOCKET_URL;
var socket = io(socket_url)
// keep track of subscriptions
var _subs = []
export default {
	subscribeBars: function(symbolInfo, resolution, updateCb, uid, resetCache) {
		if(resolution === '1D' || resolution === '1d' || resolution === 'D'){
			resolution = 'D';
		}
		//console.log(resolution)
		const channelString = createChannelString(symbolInfo)
		//console.log('tradingview before socket connected')
		socket.on('connect', () => {
			socket.emit('SubAdd', {subs:"klineRoom_"+resolution+"_"+channelString})
		})
		socket.emit('SubAdd', {subs:"klineRoom_"+resolution+"_"+channelString})
		//socket.emit('SubAdd', {subs:"klineRoom"+channelString})
		var lb = (typeof historyProvider.history[symbolInfo.name] !== 'undefined') ? historyProvider.history[symbolInfo.name].lastBar : '';
		var newSub = {
			channelString,
			uid,
			resolution,
			symbolInfo,
			lastBar: lb,
			listener: updateCb,
		}
		_subs.push(newSub)
	},
	unsubscribeBars: function(uid) {
		var subIndex = _subs.findIndex(e => e.uid === uid)
		if (subIndex === -1){
			//console.log("No subscription found for ",uid)
			return
		}
		var sub = _subs[subIndex]
		socket.emit('SubRemove', {subs: ["klineRoom_"+sub.resolution+"_"+sub.channelString]})
		//socket.emit('SubRemove', {subs: ["klineRoom"+sub.channelString]})
		_subs.splice(subIndex, 1)
	}
}

socket.on('connect', () => {
	//console.log('===Socket connected')
})
socket.on('disconnect', (e) => {
	//console.log('===Socket disconnected:', e)
})
socket.on('error', err => {
	//console.log('====socket error', err)
})
socket.on('m', (e) => {
	
	/* var dateString = e.ts,
    dateTimeParts = dateString.split(' '),
    timeParts = dateTimeParts[1].split(':'),
    dateParts = dateTimeParts[0].split('-');
	var d = Date.UTC(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2], timeParts[0], timeParts[1], timeParts[2]);
	var ts  =  d/1000; */
	var now = new Date(e.ts);
	now.setTime(now.getTime() + 330*60*1000);
	var datum = Date.parse(now);
	var ts  =  datum/1000;
	console.log(e.ts)
	console.log(ts)
	const data = {
		sub_type: e.from_sym+"_"+e.to_sym,
		exchange: e.exchange,
		to_sym: e.to_sym,
		from_sym: e.from_sym,
		trade_id: e.trade_id,
		ts: ts,
		volume: parseFloat(e.volume),
		open: parseFloat(e.open).toFixed(8),
		low: parseFloat(e.low).toFixed(8),
		high: parseFloat(e.high).toFixed(8),
		close: parseFloat(e.close).toFixed(8),
		price: parseFloat(e.price).toFixed(8)
	}	
	const channelString = e.from_sym+"_"+e.to_sym
	//console.log(channelString);
	const sub = _subs.find(e => e.channelString === channelString)
	if (sub){
		/* console.log("============")		
		console.log(sub.lastBar.time)
		console.log(data.ts)
		console.log("============") */
		// disregard the initial catchup snapshot of trades for already closed candles
		/* if(sub.lastBar !== ''){
			if (data.ts < sub.lastBar.time / 1000) {
				return
			}
		} */
		var _lastBar = updateBar(data, sub)
		// send the most recent bar back to TV's realtimeUpdate callback
		sub.listener(_lastBar)
		// update our own record of lastBar
		sub.lastBar = _lastBar
	}
})

// Take a single trade, and subscription record, return updated bar
function updateBar(data, sub){
	var lastBar = sub.lastBar
	let resolution = sub.resolution
	if (resolution.includes('D')){
		// 1 day in minutes === 1440
		resolution = 1440
	} else if (resolution.includes('W')) {
		// 1 week in minutes === 10080
		resolution = 10080
	}
	var coeff = resolution * 60
	//var rounded = Math.floor(data.ts / coeff) * coeff
	var rounded = Math.ceil(data.ts / coeff) * coeff
	var lastBarSec = (lastBar !== '') ? lastBar.time / 1000 : 0
	var _lastBar
	if(lastBar !== ''){
		/* console.log(data) */
		/* console.log(data.ts / coeff)
		console.log(Math.floor(data.ts / coeff))
		console.log(Math.floor(data.ts / coeff) * coeff) */
		/* console.log(rounded)
		console.log(lastBarSec) */
		
		if(data.exchange === 'trade'){
			if (rounded === lastBarSec){
				if (data.price < lastBar.low) {
					lastBar.low = data.price
				} else if (data.price > lastBar.high) {
					lastBar.high = data.price
				}
				lastBar.volume += data.volume
				lastBar.close = data.price
				_lastBar = lastBar
			}else{
				_lastBar = {
					time: rounded * 1000,
					open: data.open,
					high: data.high,
					low: data.low,
					close: data.close,
					volume: data.volume
				}	
			}
		}else{
			_lastBar = {
				time: rounded * 1000,
				open: data.open,
				high: data.high,
				low: data.low,
				close: data.close,
				volume: data.volume
			}	
		}
		
		/* if (rounded === lastBarSec){
			_lastBar = {
				time: rounded * 1000,
				open: data.open,
				high: data.high,
				low: data.low,
				close: data.close,
				volume: data.volume
			}	
		}else if (rounded > lastBarSec){
			_lastBar = {
				time: rounded * 1000,
				open: data.open,
				high: data.high,
				low: data.low,
				close: data.close,
				volume: data.volume
			}	
		}else{
			// update lastBar candle!
			if (data.price < lastBar.low) {
				lastBar.low = data.price
			} else if (data.price > lastBar.high) {
				lastBar.high = data.price
			}
			lastBar.time = rounded * 1000,
			lastBar.volume += data.volume
			lastBar.close = data.price
			_lastBar = lastBar
		} */
	}else{
		_lastBar = {
			time: rounded * 1000,
			open: data.open,
			high: data.high,
			low: data.low,
			close: data.close,
			volume: data.volume
		}	
	}
	return _lastBar
}

// takes symbolInfo object as input and creates the subscription string to send to CryptoCompare
function createChannelString(symbolInfo){
	/* var channel = symbolInfo.name.split(/[:/]/)
	const exchange = channel[0] === 'GDAX' ? 'Coinbase' : channel[0]
	const to = channel[2]
	const from = channel[1]
	// subscribe to the CryptoCompare trade channel for the pair and exchange
	return `0~${exchange}~${from}~${to}` */
	//var channel = symbolInfo.name.split(/[:]/)
	var channel = symbolInfo.ticker
	return channel;
}



// WEBPACK FOOTER //
// src/components/TVChartContainer/api/stream.js